import { motion } from "framer-motion";
import { ArrowLeft, NotebookPen } from "lucide-react";

const formatWhen = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const JourneyView = ({ entries, onClose, onRemove }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="absolute inset-0 z-30 bg-[#F5F3ED] overflow-y-auto"
      data-testid="journey-view"
    >
      <div className="paper-grain absolute inset-0 pointer-events-none" />

      {/* Header */}
      <div className="relative z-10 flex items-center justify-between px-6 pt-6 pb-2">
        <button
          onClick={onClose}
          data-testid="journey-back"
          aria-label="Back"
          className="rounded-full p-2 -ml-2 text-[#4A5D4E] hover:bg-[#EAE6DF] transition-colors"
        >
          <ArrowLeft className="w-5 h-5" strokeWidth={1.5} />
        </button>
        <span className="font-ui text-[10px] md:text-xs uppercase tracking-[0.4em] text-[#96918A]">
          Journey
        </span>
        <span className="w-9" />
      </div>

      <div className="relative z-10 px-6 pb-16">
        {entries.length === 0 ? (
          <div
            className="flex flex-col items-center justify-center text-center py-32 max-w-sm mx-auto"
            data-testid="journey-empty"
          >
            <NotebookPen className="w-7 h-7 text-[#96918A] mb-6" strokeWidth={1.2} />
            <p className="font-serif-verse italic text-lg md:text-xl text-[#4A5D4E] leading-relaxed">
              Your reflections will gather here.
            </p>
            <p className="font-ui text-sm text-[#6A6661] mt-3 leading-relaxed">
              A quiet record of what He has been whispering to you.
            </p>
          </div>
        ) : (
          <>
            <p className="font-serif-verse italic text-center text-sm text-[#4A5D4E] mt-4 mb-8">
              A record of what you have heard.
            </p>
            <ul
              className="space-y-3 max-w-2xl mx-auto"
              data-testid="journey-list"
            >
              {entries.map((e) => (
                <li
                  key={e.id}
                  className="rounded-xl border border-[#E5E1D8] bg-[#F5F3ED]/80 backdrop-blur-sm p-5"
                  data-testid={`journey-entry-${e.id}`}
                >
                  <div className="flex items-center justify-between gap-3">
                    <span className="font-ui text-[10px] uppercase tracking-[0.22em] text-[#96918A]">
                      {formatWhen(e.createdAt)}
                    </span>
                    <button
                      onClick={() => onRemove(e.id)}
                      data-testid={`journey-remove-${e.id}`}
                      aria-label="Remove reflection"
                      className="font-ui text-[10px] uppercase tracking-[0.2em] text-[#96918A] hover:text-[#4A5D4E] transition-colors"
                    >
                      Remove
                    </button>
                  </div>

                  <p className="mt-3 font-serif-verse text-[#05030A] text-lg md:text-xl leading-snug font-bold">
                    “{e.verse.text}”
                  </p>
                  <div className="mt-2 flex items-center gap-2">
                    <span className="font-serif-verse italic text-base text-[#05030A] font-semibold">
                      {e.verse.reference}
                    </span>
                    <span className="font-ui text-[9px] uppercase tracking-[0.2em] text-[#96918A]">
                      {e.verse.translation}
                    </span>
                  </div>

                  <div className="mt-4 pt-4 border-t border-[#E5E1D8]">
                    <p className="font-garamond text-[#0A0604] text-lg leading-relaxed italic font-medium">
                      {e.entry}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </motion.div>
  );
};
